import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { withAccount } from '../../components/AccountContext';
import AssessmentList from './AssessmentList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: AssessmentFilter
    $sort: AssessmentSortSpecifier
  ) {
    account(id: $accountId) {
      id
      assessments(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        totalCount
        indexFrom
        indexTo
        edges {
          node {
            id
            locale
            status
            createdOn
            respondent {
              id
              firstName
              lastName
              email
            }
            template {
              id
              title
            }
          }
        }
      }
    }
  }
`;

class AssessmentListContainer extends Component {
  static propTypes = {
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    currentAccount: PropTypes.number.isRequired,
  };

  render() {
    const { currentAccount, location, translatedTags } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      sort: params.sort || { sortBy: 'createdOn', sortDir: 'DESC' },
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account ? data.account.assessments : emptyConnection();
          return (
            <Fragment>
              <AssessmentList
                connection={connection}
                currentAccount={currentAccount}
                translatedTags={translatedTags}
                loading={loading}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

AssessmentListContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default withRouter(injectIntl(connect(mapState)(withAccount(AssessmentListContainer))));
